import { currentLocale } from './i18n';

/** All dates arrive in UTC (ISO 8601) and are converted here, only for display (CLAUDE.md §14). */

export function formatTime(iso: string | null | undefined, withSeconds = false): string {
  if (iso === null || iso === undefined) return '—';
  return new Intl.DateTimeFormat(currentLocale(), {
    hour: '2-digit',
    minute: '2-digit',
    ...(withSeconds ? { second: '2-digit' } : {}),
  }).format(new Date(iso));
}

export function formatDate(iso: string | null | undefined): string {
  if (iso === null || iso === undefined) return '—';
  return new Intl.DateTimeFormat(currentLocale(), {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(iso));
}

export function formatDateTime(iso: string | null | undefined): string {
  if (iso === null || iso === undefined) return '—';
  return new Intl.DateTimeFormat(currentLocale(), {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
}

export function formatNumber(value: number, options: Intl.NumberFormatOptions = {}): string {
  return new Intl.NumberFormat(currentLocale(), options).format(value);
}

export function formatPercent(value: number): string {
  return `${formatNumber(value)}%`;
}

/** HH:MM:SS elapsed since `iso`, as the mission timer of the topbar shows it. */
export function formatElapsed(iso: string, now: number = Date.now()): string {
  const seconds = Math.max(0, Math.floor((now - new Date(iso).getTime()) / 1000));
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const two = (n: number) => String(n).padStart(2, '0');
  return `${two(h)}:${two(m)}:${two(s)}`;
}

/** Relative minutes ("21 min") in the current language through Intl.RelativeTimeFormat. */
export function formatMinutesAgo(minutes: number): string {
  const formatter = new Intl.RelativeTimeFormat(currentLocale(), {
    numeric: 'always',
    style: 'short',
  });
  return formatter.format(-minutes, 'minute');
}

export function formatCoordinates(lng: number, lat: number): string {
  const ns = lat >= 0 ? 'N' : 'S';
  const ew = lng >= 0 ? 'E' : 'W';
  return `${Math.abs(lat).toFixed(4)} ${ns} · ${Math.abs(lng).toFixed(4)} ${ew} · WGS84`;
}

/** Picks the label of a configurable state in the current language, falling back to Italian. */
export function stateLabel(labels: Record<string, string>, key: string): string {
  return labels[currentLocale()] ?? labels['it'] ?? key;
}
